import { render, staticRenderFns } from "./FfgContent.vue?vue&type=template&id=14a84158&"
import script from "./FfgContent.vue?vue&type=script&lang=js&"
export * from "./FfgContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports